import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  Checkbox,
  Dropdown,
  Input,
  Menu
} from 'semantic-ui-react'

import { getValue } from '_utils';

const statusOptions = [
  { text: 'All Licenses', value: 'all' },
  { text: 'Only Claimed', value: 'claimed' },
  { text: 'Only Unclaimed', value: 'unclaimed' }
]

const ActivationCodeFilterMenu = ({ onChange, filters }) => {

  const onStatusChange = (e, data) => onChange(Object.assign({}, filters, { [data.name]: getValue(data) }));
  const onChangeExpired = (e, data) => onChange(Object.assign({}, filters, { [data.name]: data.checked }));
  const onSearchChange = (e) => onChange(Object.assign({}, filters, { [e.target.name]: e.target.value }));

  return (
    <Fragment>
      <Menu.Item>
        <Input autoComplete='off' icon='search' iconPosition='left' name='term' placeholder='Search Licenses' value={ filters.term } onChange={ onSearchChange } />
      </Menu.Item>
      <Dropdown
        item
        simple
        direction='right'
        name='status'
        closeOnChange
        onChange={ onStatusChange }
        options={ statusOptions.map(o => Object.assign({}, o, { key: o.value })) }
        value={ filters.status }
      />
      <Menu.Item>
        <Checkbox onChange={ onChangeExpired } label='Show Expired' toggle fitted size='tiny' name='showExpired' checked={ filters.showExpired } />
      </Menu.Item>
    </Fragment>
  );
};

ActivationCodeFilterMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    term: PropTypes.string.isRequired,
    showExpired: PropTypes.bool.isRequired,
    status: PropTypes.oneOf(statusOptions.map(o => o.value)).isRequired
  }).isRequired
};

export default ActivationCodeFilterMenu;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/filter.js